import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const Documents = ({ value }) => {
  return (
    <Typography sx={{ fontWeight: '600', color: 'text.grey', textAlign: 'center' }}>
      {value}
    </Typography>
  );
};

export default Documents;

Documents.propTypes = {
  value: PropTypes.number
};
